/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style5 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _style6 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style7 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _style8 = require('antd/lib/tabs/style');

var _tabs = require('antd/lib/tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _tpl = require('tpl');

var _tpl2 = _interopRequireDefault(_tpl);

var _tool = require('util/tool');

var _config = require('util/config');

require('./index.less');

var _reactFreeScrollbar = require('react-free-scrollbar');

var _reactFreeScrollbar2 = _interopRequireDefault(_reactFreeScrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabPane = _tabs2.default.TabPane;
var Search = _input2.default.Search;

var _ref = (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_button2.default, {
  icon: 'check-circle-o',
  className: 'list-body-btn'
}));

var _ref2 = (0, _jsx3.default)('div', {});

var _ref3 = (0, _jsx3.default)('div', {
  className: 'tip'
}, void 0, '\u6682\u65E0\u6570\u636E,\u8BF7\u8F93\u5165\u7AD9\u70B9\u540D\u79F0\u8FDB\u884C\u641C\u7D22\uFF01');

var _ref4 = (0, _jsx3.default)('div', {
  className: 'tip'
}, void 0, '\u6682\u65E0\u6570\u636E\uFF0C\u8BF7\u4ECE\u53F3\u4FA7\u70B9\u51FB\u9009\u53D6\uFF01');

var _ref5 = (0, _jsx3.default)('p', {}, void 0, '\u63A5\u5165\u8BBE\u5907\u6570');

var _ref6 = (0, _jsx3.default)('h1', {
  className: 'title'
}, void 0, '\u5F85\u5347\u7EA7\u7684\u7AD9\u70B9');

var _ref7 = (0, _jsx3.default)('h1', {
  className: 'title'
}, void 0, '\u9009\u62E9\u9700\u8981\u5347\u7EA7\u7684\u7AD9\u70B9');

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.ClickStation = function (k) {
      //console.log(this)
      var stationListStr = (0, _stringify2.default)([].concat((0, _toConsumableArray3.default)(_this.state.stationList)));
      var stationList = JSON.parse(stationListStr);
      var selectListStr = (0, _stringify2.default)([].concat((0, _toConsumableArray3.default)(_this.state.selectedList)));
      var selectedList = JSON.parse(selectListStr);
      stationList[k].isShow = true;
      selectedList[k] = stationList[k];
      _this.setState({
        stationList: stationList, selectedList: selectedList
      });
    };

    _this.RemoveStation = function (k) {
      var stationListStr = (0, _stringify2.default)([].concat((0, _toConsumableArray3.default)(_this.state.stationList)));
      var stationList = JSON.parse(stationListStr);
      var selectListStr = (0, _stringify2.default)([].concat((0, _toConsumableArray3.default)(_this.state.selectedList)));
      var selectedList = JSON.parse(selectListStr);
      stationList[k].isShow = false;
      selectedList[k] = null;
      _this.setState({
        stationList: stationList, selectedList: selectedList
      });
    };

    _this.nextStep = function () {
      window.localStorage.removeItem("stationIds");
      var selectedList = _this.state.selectedList;

      if (selectedList.length) {
        var stationIds = [];
        selectedList.map(function (item) {
          if (item) {
            stationIds.push(item.stationId);
          }
        });
        var stationStr = (0, _stringify2.default)(stationIds);
        window.localStorage.setItem("stationIds", stationStr);
        var id = _this.props.params.id;

        _this.props.router.push({
          pathname: '/remote/' + id + '/updateByStation'
        });
      } else {
        _message2.default.error("请选择升级站点！");
      }
    };

    _this.state = {
      baseInfo: {
        deviceVersions: []
      },
      stationList: [],
      selectedList: []
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'updateRoute',
    value: function updateRoute(id) {
      this.props.router.push({
        pathname: '/remote/' + id + '/update'
      });
    }
  }, {
    key: 'goRoute',
    value: function goRoute(path) {
      this.props.router.push({
        pathname: path
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var params = this.props.params;

      var options = { productId: params.id };
      (0, _tool.http)(_config.apiJson.getProduct, options).then(function (res) {
        _this2.setState({
          baseInfo: res
        });
      });
    }
  }, {
    key: 'getStationList',
    value: function getStationList() {
      var _this3 = this;

      var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      var options = {
        keywords: keywords
      };
      (0, _tool.http)(_config.apiJson.getStationList, options).then(function (res) {

        //console.log(res)
        _this3.setState({
          stationList: res,
          selectedList: []
        });
      });
    }
  }, {
    key: 'routeToVersion',
    value: function routeToVersion() {
      var params = this.props.params;

      this.props.router.push({
        pathname: '/remote/' + params.id + '/version'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var params = this.props.params;
      var _state = this.state,
          baseInfo = _state.baseInfo,
          stationList = _state.stationList,
          selectedList = _state.selectedList;

      var options = [];
      var selects = [];
      stationList.map(function (item, id) {
        var tpl = (0, _jsx3.default)('div', {
          className: 'list-body',
          onClick: _this4.ClickStation.bind(_this4, id)
        }, id, (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)('p', {
          className: 'list-body-title'
        }, void 0, item.stationName), (0, _jsx3.default)('p', {
          className: 'list-body-cont'
        }, void 0, item.address)), item.isShow ? _ref : _ref2);
        options.push(tpl);
      });

      options = options.length ? options : _ref3;

      selectedList.map(function (item, id) {
        if (item) {
          var tpl = (0, _jsx3.default)('div', {
            className: 'selet-body'
          }, id, (0, _jsx3.default)('div', {}, void 0, item.stationName), (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_button2.default, {
            icon: 'close-circle-o',
            className: 'list-body-btn',
            onClick: _this4.RemoveStation.bind(_this4, id)
          })));
          selects.push(tpl);
        }
      });
      selects = selects.length ? selects : _ref4;
      return (0, _jsx3.default)('div', {
        className: 'remote-level'
      }, void 0, (0, _jsx3.default)(_tabs2.default, {
        defaultActiveKey: '1'
      }, void 0, (0, _jsx3.default)(TabPane, {
        tab: '\u6309\u8BBE\u5907\u7CFB\u5217\u5347\u7EA7'
      }, '1', (0, _jsx3.default)('div', {
        className: 'level-text'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'text-time'
      }, void 0, (0, _jsx3.default)('p', {}, void 0, baseInfo.name), (0, _jsx3.default)('p', {}, void 0, '\u4E0A\u6B21\u66F4\u65B0\u65F6\u95F4\uFF1A', baseInfo.createTime ? baseInfo.createTime : "--"), (0, _jsx3.default)('p', {}, void 0, '\u4E0A\u6B21\u66F4\u65B0\u7248\u672C\uFF1A', baseInfo.lastUpgradeVersion ? baseInfo.lastUpgradeVersion : "--")), (0, _jsx3.default)('div', {
        className: 'text-nums'
      }, void 0, (0, _jsx3.default)('p', {}, void 0, (0, _jsx3.default)('span', {}, void 0, baseInfo.deviceCount), '\u4E2A'), _ref5), (0, _jsx3.default)('div', {
        className: 'text-level'
      }, void 0, (0, _jsx3.default)('p', {}, void 0, baseInfo.versionCount), (0, _jsx3.default)('p', {}, void 0, '\u7248\u672C\u6570\u91CF', (0, _jsx3.default)('span', {}, void 0, (0, _jsx3.default)('a', {
        href: 'javascript:void(0);',
        onClick: this.routeToVersion.bind(this)
      }, void 0, '\u67E5\u770B\u5206\u5E03'))))), (0, _jsx3.default)('div', {
        className: 'level-btn'
      }, void 0, (0, _jsx3.default)(_button2.default, {
        type: 'primary',
        className: 'btn',
        style: { height: '50px' },
        onClick: this.updateRoute.bind(this, params.id)
      }, void 0, '\u66F4\u65B0\u7248\u672C'), (0, _jsx3.default)(_button2.default, {
        className: 'btn',
        style: { height: '50px' },
        onClick: this.goRoute.bind(this, '/remote/' + params.id + '/records')
      }, void 0, '\u5347\u7EA7\u8BB0\u5F55'))), (0, _jsx3.default)(TabPane, {
        tab: '\u6309\u7AD9\u70B9\u5347\u7EA7'
      }, '2', (0, _jsx3.default)('div', {
        className: 'level-upadte'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'level-box text-left'
      }, void 0, _ref6, (0, _jsx3.default)('div', {
        className: 'box'
      }, void 0, (0, _jsx3.default)(_reactFreeScrollbar2.default, {}, void 0, selects)), (0, _jsx3.default)('div', {
        className: 'btn'
      }, void 0, (0, _jsx3.default)(_button2.default, {
        type: 'primary',
        className: 'nextStep',
        onClick: this.nextStep.bind(this)
      }, void 0, '\u4E0B\u4E00\u6B65'))), (0, _jsx3.default)('div', {
        className: 'level-box text-right'
      }, void 0, _ref7, (0, _jsx3.default)('div', {
        className: 'box'
      }, void 0, (0, _jsx3.default)(Search, {
        placeholder: '\u641C\u7D22\u7AD9\u70B9',
        onSearch: this.getStationList.bind(this),
        style: { width: 200 }
      }), (0, _jsx3.default)('div', {
        className: 'level-list'
      }, void 0, (0, _jsx3.default)(_reactFreeScrollbar2.default, {}, void 0, options))))))));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  id: '', // 应用关联使用的redux
  component: Main, // 接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/remote/level/index.jsx
// module id = 1500
// module chunks = 0